// components/CustomEchart.jsx
import React, { useRef, useState } from "react";
import Select from 'react-select'
import ReactECharts from "echarts-for-react";
import { baseOption, sortLogic } from "../creative/report/reports/helpers";
import DropdownIndicator from "../render-helpers/dropDownIndicator.js"
import { isEmpty } from "lodash";
import "./index.scss"
import classNames from "classnames";

export default function CustomEchart({ type, dataSource = baseOption, options = {}, height = "", width = "", hasSorting = false, sortData, attentionData, limit = 5, vertical = false, lumen = false, perMinute = true, isEmissions = false, chartClass = "", ...props }) {
  const chartRef = useRef();
  const [sortBy, setSortBy] = useState(props.defaultSortEmpty ? "" : "1")
  const [sorters, setSorters] = useState({})
  const [dataSourceState, setDataSourceState] = useState({})
  // const chartColour = { main: "#f9d7f0", base: "#f2f2f2" }
  // const chartColour = {
  //   main: "#f9d7f0", base: "#f2f2f2",
  //   light: "#ffffff",
  //   dark: "#000000",
  //   neutral: "#cccccc",
  //   highlight: "#2496fa",
  //   accent1: "#8cca8b",
  //   accent2: "#e06e5e",
  //   accent3: "#fec663",
  //   accent4: "#1272a4",
  //   gridLine: "#eee",
  //   axis: "#ccc",
  //   subtext: "#666"
  // };

  // const baseTooltip = {
  //   backgroundColor: chartColour.light,
  //   borderColor: chartColour.neutral,
  //   borderWidth: 1,
  //   textStyle: { color: chartColour.dark },
  // };


  const searchByFilter = (e) => {
    const sortBy = e.value;
    let sorted = { property: 'impressions', direction: "ASC" }
    if (isEmissions) {
      switch (sortBy) {
        case "0":
          sorted = { property: 'total', direction: "ASC" }
          break;
        case "1":
          sorted = { property: 'total', direction: "DESC" }
          break;
        default: break;
      }
    } else {
      // eslint-disable-next-line
      if (sortBy == 0) {
        sorted = { property: 'impressions', direction: "ASC" }
      }
      // eslint-disable-next-line
      else if (sortBy == 1) {
        sorted = { property: 'impressions', direction: "DESC" }
      }
      if (!lumen) {
        // eslint-disable-next-line
        if (sortBy == 2) {
          sorted = { property: 'avgTotalAttention', direction: "ASC" }
        }
        // eslint-disable-next-line
        else if (sortBy == 3) {
          sorted = { property: 'avgTotalAttention', direction: "DESC" }
        }
      } else {
        // eslint-disable-next-line
        if (sortBy == 2) {
          sorted = { property: 'apm', direction: "ASC" }
        }
        // eslint-disable-next-line
        else if (sortBy == 3) {
          sorted = { property: 'apm', direction: "DESC" }
        }
      }
      // eslint-disable-next-line  
    }

    let dataSourceState = sortLogic(sorted, attentionData, dataSource && dataSource?.chart?.caption, limit, vertical, lumen, perMinute, dataSource?.chart?.subcaption || "", isEmissions)
    setSortBy(sortBy)
    setSorters(sorted)
    setDataSourceState(dataSourceState)
  }



  const rendersortBy = () => {
    return (
      <div className="d-flex flex-row flex-wrap justify-content-between align-items-center mb-3">
        <label className="bb-body-txt mr-2 mb-0 align-self-center pt-0 mb-1 bb-label-color">Sort {dataSource?.title?.text} by</label>
        <Select
          options={sortData}
          value={sortBy ? sortData[sortBy] : ""}
          onChange={searchByFilter}
          placeholder="Choose..."
          classNamePrefix="max-width bb-select-light"
          menuPortalTarget={document.body}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          menuPlacement="auto"
          components={{ DropdownIndicator }}
        />
      </div>
    )
  }


  const option = isEmpty(dataSourceState) ? {...dataSource, ...options} : {...dataSourceState, ...options}
  return (
    <div style={{ textAlign: "center" }}>
      {hasSorting ? rendersortBy() : null}
      <div className={classNames("buddy-echart", chartClass)}>
        <ReactECharts notMerge={true} ref={chartRef} option={option} style={{ height: height || "100%", width: width || "100%" }} />
      </div>
    </div>
  );
}

//createAbsoluteDataSet, createPercentageDataSet, renderGaugeData, addonDataEmissions, createStackedColumnDataSet, createAttentionScore, createAbsoluteDataSetDOOH